import axios from "axios";
import { Base_URL } from "../url";

export const fetchDeductions = async (organisationId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/DeductionMasterGet?Org_id=${organisationId}`
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching deductions!";
  }
};
